import { withBemMod } from '@bem-react/core';
import React from 'react';

import HtmlContent from 'client/common/components/html-content';
import { ILevelMedia } from 'client/common/types';

import { b, ILevelProps } from '..';

import './level_type_thumb.css';

export interface ILevelTypeThumbProps extends Omit<ILevelMedia, 'type'> {
    type?: 'thumb';
}

export const withLevelTypeThumb = withBemMod<ILevelTypeThumbProps, ILevelProps>(
    b(),
    { type: 'thumb' },
    (BaseLevel: React.FC<ILevelProps>) => props => {
        const { textAlign, contentDescription, blocks, ...otherProps } = props;

        const imageSrc = blocks && blocks.length > 0 && blocks[0].image;

        const alignMod = textAlign ? { align: textAlign } : {};

        return (
            <BaseLevel {...otherProps}>
                <div className={b('content', alignMod)}>
                    {contentDescription && (
                        <HtmlContent
                            className={b('content-description')}
                            content={contentDescription}
                            />
                    )}
                    {imageSrc && <img className={b('image')} src={imageSrc} />}
                </div>
            </BaseLevel>
        );
    }
);
